import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';

// Import all Derivatives elements
import DerivativesElement1 from './derivatives-elements/DerivativesElement1';
import DerivativesElement2 from './derivatives-elements/DerivativesElement2';
import DerivativesElement3 from './derivatives-elements/DerivativesElement3';
import DerivativesElement4 from './derivatives-elements/DerivativesElement4';
import DerivativesElement5 from './derivatives-elements/DerivativesElement5';
import DerivativesElement6 from './derivatives-elements/DerivativesElement6';
import DerivativesElement7 from './derivatives-elements/DerivativesElement7';
import DerivativesElement8 from './derivatives-elements/DerivativesElement8';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const DerivativesElement = () => {
  const { elementId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [hasAccess, setHasAccess] = useState(false);
  const [verifying, setVerifying] = useState(true);
  const token = searchParams.get('token') || localStorage.getItem('derivatives_access_token');

  useEffect(() => {
    const verifyAccess = async () => {
      if (!token) {
        navigate('/books/derivatives-interactive');
        return;
      }

      try {
        const response = await fetch(
          `${API_URL}/api/books/derivatives-interactive/verify-access?token=${token}`
        );
        const data = await response.json();
        
        if (data.valid) {
          setHasAccess(true);
          localStorage.setItem('derivatives_access_token', token);
        } else {
          navigate('/books/derivatives-interactive');
        }
      } catch (error) {
        console.error('Error verifying access:', error);
        navigate('/books/derivatives-interactive');
      } finally {
        setVerifying(false);
      }
    };

    verifyAccess();
  }, [token, navigate]);

  if (verifying) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#ffffff'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            fontSize: '24px', 
            color: '#111827',
            marginBottom: '16px'
          }}>
            Verifying access...
          </div>
        </div>
      </div>
    );
  }

  if (!hasAccess) {
    return null;
  }

  // Map element IDs to components
  const elementComponents = {
    'element-1': DerivativesElement1,
    'element-2': DerivativesElement2,
    'element-3': DerivativesElement3,
    'element-4': DerivativesElement4,
    'element-5': DerivativesElement5,
    'element-6': DerivativesElement6,
    'element-7': DerivativesElement7,
    'element-8': DerivativesElement8,
  };

  const ElementComponent = elementComponents[elementId];

  if (!ElementComponent) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#ffffff'
      }}>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ color: '#111827', fontSize: '32px', marginBottom: '16px' }}>
            Element Not Found
          </h1>
          <button
            onClick={() => navigate('/books/derivatives-interactive')}
            style={{
              padding: '12px 24px',
              background: '#8b5cf6',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Back to Derivatives Study Guide
          </button>
        </div>
      </div>
    );
  }

  return <ElementComponent />;
};

export default DerivativesElement;
